(function () {
    const authorGuidelines = {
        // get navbar and pass data
        //
        init: () => {
            authorGuidelines.initNavbar();
        },

        initNavbar: () => {
            const container = document.querySelector('.custom-content__guidelines-nav');
            if (typeof UX.sectionsNavbar === 'object' && container) {
                const sections = document.querySelectorAll('.guidelines--section'); // @TODO maybe better to use full name? -> table-of-content
                const titles = Array.prototype.slice.call(sections).map(o => {
                    const preparedTitle = o.querySelector('.to-section');
                    if (preparedTitle) {
                        preparedTitle.sectionParent = o;
                        return preparedTitle;
                    }
                });
                if (titles.length) {
                    container.classList.remove('hidden');
                    UX.sectionsNavbar.init(titles);
                }
            }
        },
    };
    UX.authorGuidelines = authorGuidelines;
})();
